<template>
  <div>
    <HeraFormInput
      key="points-for-tie-field"
      v-model="pointsForTie"
      v-validate="'required|numeric|decimal:0|min_value:0'"
      :label="$$t('Number of points for tie:', 'points-for-tie')"
      required
      size="2"
      class="tie-points-input"
      :class="{ 'is-invalid': errors.first('points-for-tie') }"
      :view-mode="disabled"
      :disabled="isStageFieldDisabled('pointsForTie') || disabled"
      name="points-for-tie"
      :error="errors.first('points-for-tie')"
    />
  </div>
</template>

<script>
import { translate } from '@/mixins/translate';
import HeraFormInput from '@/components/atoms/form/HeraFormTextInput';
import stageSetupHelpers from '@/views/tournaments/management/singleTournament/mixins/stageHelpers';
import { prop } from '@/utils/factories';
export default {
  name: 'StagePointsForTieSetting',
  components: {
    HeraFormInput,
  },
  inject: ['$validator'],
  mixins: [translate('_web_tournament_stage-editor'), stageSetupHelpers],
  props: {
    disabled: prop(Boolean),
  },
  computed: {
    pointsForTie: {
      get() {
        return this.getBlockConfigurationByKey('points_tie');
      },
      set(newVal) {
        this.setBlockConfigurationByKey('points_tie', newVal);
      },
    },
  },
};
</script>

<style></style>
